import axios from "axios";
import Vue from "vue";
import { BASEURL } from "@/config";
import cookieType from "@/config/cookieType";
import router from "@/router";
import notification from "ant-design-vue/es/notification";
import store from "@/store";

export default () => {
  const instance = axios.create({
    baseURL: BASEURL
  });
  // Vue.cookie.get(cookieType.MCHASHID)
  const MCHASHID =localStorage.getItem('MCHASHID')
  MCHASHID
    ? (instance.defaults.headers.common["Authorization"] = MCHASHID
      )
    : undefined;
  instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      if (!error["response"]) {
        if (status) {
          showErrorMessage("Your authorization token is invalid or expired");
          // redirect to auth page or login again
          router.push({
            path: "/login"
          });
        }

        return Promise.reject(error);
      } else if (error.response.status == 403) {
        showErrorMessage("Your authorization token is invalid or expired");
        // redirect to auth page or login again
        router.push({
          path: "/login"
        });
      } else if (error.response.status == 401) {
        // store.dispatch("Account/onLogoutUser")
        window.location.replace("/login");
        // router.push({
        //   path: "/login"
        // });
        showErrorMessage(
          "Something went wrong. kindly contact your administrator"
        );
      } else {
        // showErrorMessage(
        //   "Something went wrong. kindly contact your administrator"
        // );
      }
      return Promise.reject(error.response);
    }
  );
  return instance;
};

const showErrorMessage = message => {
  notification.error({
    message: "Oops!",
    description: message
  });
};
